// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import '@hotwired/turbo-rails'
import './controllers'
import * as bootstrap from 'bootstrap'
import * as Leaflet from 'leaflet'
import * as MarkerCluster from 'leaflet.markercluster'
import 'tom-select';
import TomSelect from "tom-select";
window.TomSelect = TomSelect;

import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }

window.bootstrap = bootstrap
// window.TomSelect = TomSelect
window.Leaflet = Leaflet
window.MarkerCluster = MarkerCluster;
